import React, { useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { IAllStates } from '../../../store/rootReducer';
import { openUpgradeModal } from '../../../store/subscription/subscriptionSlice';
import { SubscriptionStatusEnum } from '../../../enum/SubscriptionStatusEnum';
import SubscriptionPlanBadge from './SubscriptionPlanBadge';
import { UserRoles } from '../../../enum/UserRoles';
import { GlobalDiscoveryService } from '../../../app/brand/global-discovery/service';
import { ErrorToast } from '../../../utils/toasters';
import { MUTED_TEXT_COLOR, WARNING_COLOR } from '../../../utils/constants';

const StripeHeaderComponent = () => {
    const userType = useSelector((states: IAllStates) => states.auth?.user?.userType);
    const activePackage = useSelector((states: IAllStates) => states.auth?.user?.company?.package);
    const currentSubscription = useSelector((states: IAllStates) => states.auth?.user?.currentSubscription);
    const [isLoading, setIsLoading] = useState(false);
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const isBrandRole = userType === UserRoles.BRAND;
    const packageStatus = currentSubscription?.status;
    const isTrial = packageStatus === SubscriptionStatusEnum.TRIALING;
    const isCanceled = packageStatus === SubscriptionStatusEnum.CANCELED;
    const isPastDue = packageStatus === SubscriptionStatusEnum.PAST_DUE;
    const isActive = packageStatus === SubscriptionStatusEnum.ACTIVE;
    const withoutStripe = activePackage?.name === 'discovery';
    const trialDuration = process.env.VITE_TRIAL_DURATION;
    const packageColor = isPastDue ? WARNING_COLOR : activePackage?.color || MUTED_TEXT_COLOR;
    const packageName = activePackage?.displayName || t('general.stripe.free_plan');
    const trialLabel = isTrial ? `Trial ${currentSubscription?.trialDaysLeft}/${trialDuration} days` : undefined;

    const updatePaymentApiRequest = async () => {
        try {
            setIsLoading(true);
            const response = await GlobalDiscoveryService.cancelSubscription();
            window.location.href = response.url;
        } catch (err) {
            await ErrorToast(err);
        }
    };

    const openUpgradeModalAction = () => {
        dispatch(
            openUpgradeModal({
                source: 'header',
            })
        );
        return;
    };

    const onSubmitAction = () => {
        isPastDue ? updatePaymentApiRequest() : openUpgradeModalAction();
    };
    return (
        <div className="d-flex">
            <SubscriptionPlanBadge
                name={packageName}
                isActive={isActive ? t('general.stripe.active') : undefined}
                isPastDue={isPastDue ? t('general.stripe.payment_failed_label') : undefined}
                isTrial={isTrial}
                trialLabel={trialLabel}
                color={packageColor}
            />{' '}
            {!isBrandRole && !withoutStripe && (
                <Button
                    className="ml-md-2 ml-1 mr-1 mr-md-0"
                    onClick={onSubmitAction}
                    variant={isPastDue ? 'outline-warning' : 'outline-primary'}
                    disabled={isLoading}
                >
                    {isActive
                        ? t(`general.stripe.manage_plan`)
                        : isTrial || isCanceled
                        ? t(`general.stripe.upgrade_now`)
                        : isPastDue
                        ? t(`general.stripe.update_payment`)
                        : t(`general.stripe.start_trial`)}
                </Button>
            )}
        </div>
    );
};

export default StripeHeaderComponent;
